// src/components/activity-item/ActivityItem.tsx
import {
Body1,
Body2,
Flex,
Stack,
Subtitle2,
TextButton
} from "@phx/design-system";
import {formatDate} from "@phx/design-system/framework";
import {useTranslation} from "react-i18next";
import {
jsx,
jsxs
} from "react/jsx-runtime";
var ActivityItem = ({
  pharmacyName,
  date,
  onClickTextButton
}) => {
  const { t } = useTranslation("phx-lib");
  return /* @__PURE__ */ jsxs(Flex, {
    justify: "space-between",
    children: [
      /* @__PURE__ */ jsxs(Stack, {
        gap: 0,
        children: [
          /* @__PURE__ */ jsx(Subtitle2, {
            children: t("activityItem.sentToPharmacy")
          }),
          /* @__PURE__ */ jsxs(Stack, {
            gap: "xs",
            children: [
              pharmacyName ? /* @__PURE__ */ jsx(Body1, {
                children: pharmacyName
              }) : null,
              /* @__PURE__ */ jsx(Flex, {
                justify: "none",
                children: /* @__PURE__ */ jsx(TextButton, {
                  onClick: onClickTextButton,
                  children: t("activityItem.viewOrder")
                })
              })
            ]
          })
        ]
      }),
      date ? /* @__PURE__ */ jsx(Body2, {
        children: formatDate(date, { dateStyle: "medium" })
      }) : null
    ]
  });
};

// src/components/alternative-card/AlternativeCard.tsx
import {ElevatedCard, Stack as Stack5} from "@phx/design-system";
import {useTranslation as useTranslation2} from "react-i18next";

// src/util/currency/currency.ts
var formatToLocalizedCurrency = (number, options) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    ...options
  }).format(number);
};

// src/components/pricing-info/PricingInfo.tsx
import {Body1 as Body12, Flex as Flex2, Stack as Stack2, Subtitle2 as Subtitle22} from "@phx/design-system";
import {
jsx as jsx2,
jsxs as jsxs2
} from "react/jsx-runtime";
var PricingInfo = ({ option, details, value }) => {
  return /* @__PURE__ */ jsxs2(Flex2, {
    justify: "space-between",
    children: [
      /* @__PURE__ */ jsxs2(Stack2, {
        gap: 0,
        children: [
          /* @__PURE__ */ jsx2(Subtitle22, {
            children: option
          }),
          details ? /* @__PURE__ */ jsx2(Body12, {
            children: details
          }) : null
        ]
      }),
      /* @__PURE__ */ jsx2(Subtitle22, {
        children: value
      })
    ]
  });
};

// src/components/pricing-info/PricingInfoList.tsx
import {HorizontalDivider, Stack as Stack3} from "@phx/design-system";
import {
jsx as jsx3,
jsxs as jsxs3,
Fragment
} from "react/jsx-runtime";
var PricingInfoList = ({ pricing }) => {
  return /* @__PURE__ */ jsx3(Fragment, {
    children: pricing.map((info, index) => {
      return /* @__PURE__ */ jsxs3(Stack3, {
        gap: "sm",
        children: [
          /* @__PURE__ */ jsx3(PricingInfo, {
            option: info?.option,
            details: info?.details,
            value: info?.value
          }),
          index !== pricing.length - 1 ? /* @__PURE__ */ jsx3(HorizontalDivider, {}) : null
        ]
      }, `${info?.option}-${index}`);
    })
  });
};

// src/components/alternative-card/internal/HeaderGroup.tsx
import {Body1 as Body13, Stack as Stack4, Subtitle1} from "@phx/design-system";
import {
jsx as jsx4,
jsxs as jsxs4
} from "react/jsx-runtime";
var HeaderGroup = ({ title, description }) => {
  return /* @__PURE__ */ jsxs4(Stack4, {
    gap: "xxs",
    children: [
      /* @__PURE__ */ jsx4(Subtitle1, {
        children: title
      }),
      description ? /* @__PURE__ */ jsx4(Body13, {
        children: description
      }) : null
    ]
  });
};

// src/components/alternative-card/internal/Tags.tsx
import {Badge, Flex as Flex3} from "@phx/design-system";
import {
jsx as jsx5
} from "react/jsx-runtime";
var Tags = ({ tags }) => {
  return /* @__PURE__ */ jsx5(Flex3, {
    gap: "xs",
    children: tags.map(({ label, color }, idx) => /* @__PURE__ */ jsx5(Badge, {
      color,
      children: label
    }, `${label}-${idx}`))
  });
};

// src/components/alternative-card/AlternativeCard.tsx
import {
jsx as jsx6,
jsxs as jsxs5
} from "react/jsx-runtime";
var AlternativeCard = ({
  product: { name, description },
  pricing,
  role,
  patientSavings,
  planSavings,
  onClick
}) => {
  const { t } = useTranslation2("phx-lib");
  const tags = [];
  if (patientSavings > 1) {
    tags.push({
      label: t("alternatives.saveTag", {
        amount: formatToLocalizedCurrency(patientSavings)
      }),
      color: "success"
    });
  }
  if (planSavings >= 20) {
    tags.push({
      label: t("alternatives.planSaveTag", {
        amount: formatToLocalizedCurrency(planSavings)
      }),
      color: "info"
    });
  }
  return /* @__PURE__ */ jsx6(ElevatedCard, {
    header: /* @__PURE__ */ jsx6(Tags, {
      tags
    }),
    role,
    onClick,
    children: /* @__PURE__ */ jsxs5(Stack5, {
      gap: "sm",
      children: [
        /* @__PURE__ */ jsx6(HeaderGroup, {
          title: name,
          description
        }),
        pricing ? /* @__PURE__ */ jsx6(PricingInfoList, {
          pricing
        }) : null
      ]
    })
  });
};

// src/components/coverage-card/CoverageCard.tsx
import {
BaseCard,
Box,
Container,
Flex as Flex4,
Stack as Stack6,
Text
} from "@phx/design-system";
import {constants} from "@phx/design-system/framework";
import {useTranslation as useTranslation3} from "react-i18next";

// __style_helper__
function injectStyle(text) {
  if (typeof document !== "undefined") {
    const styleTag = document.getElementById("bun_lightningcss");
    if (styleTag) {
      const node2 = document.createTextNode(text);
      styleTag.appendChild(node2);
      return;
    }
    var style = document.createElement("style");
    style.id = "bun_lightningcss";
    var node = document.createTextNode(text);
    style.appendChild(node);
    document.head.appendChild(style);
  }
}

// src/components/coverage-card/coverage-card.module.css
injectStyle(".dZZB-q_smartprice-card{background-image:url(/static/libraries/myphx-lib/coverage-card/smartprice-background.svg);background-repeat:no-repeat;background-size:cover;background-color:var(--mantine-primary-color-filled);border-color:var(--mantine-primary-color-filled);width:100%;height:100%}.dZZB-q_benefit-card{border:1px solid var(--mantine-color-gray-2);background-image:url(/static/libraries/myphx-lib/coverage-card/pbm-pattern.svg);background-position:100% 100%;background-repeat:no-repeat;background-size:auto 40%;width:100%;height:100%}.dZZB-q_container{width:220px;height:147px}@container (width>=260px){.dZZB-q_container{width:260px;height:174px}}@container (width>=300px){.dZZB-q_container{width:300px;height:200px}}@container (width>=350px){.dZZB-q_container{width:350px;height:234px}}.dZZB-q_contentWrapper{padding:var(--mantine-spacing-xxs);gap:var(--mantine-spacing-xxs)!important}@container (width>=260px){.dZZB-q_contentWrapper{padding:var(--mantine-spacing-xs);gap:var(--mantine-spacing-xs)!important}}@container (width>=300px){.dZZB-q_contentWrapper{padding:var(--mantine-spacing-sm);gap:var(--mantine-spacing-sm)!important}}.dZZB-q_nameWrapper{gap:0!important}@container (width>=260px){.dZZB-q_nameWrapper{gap:var(--mantine-spacing-xxs)!important}}@container (width>=300px){.dZZB-q_nameWrapper{gap:var(--mantine-spacing-xs)!important}}.dZZB-q_detailsWrapper{gap:var(--mantine-spacing-xs)}@container (width>=260px){.dZZB-q_detailsWrapper{gap:var(--mantine-spacing-sm)}}.dZZB-q_logo{padding:var(--mantine-spacing-xxxs)var(--mantine-spacing-xxs);border-radius:0 0 1.5rem;width:112px;height:40px}.dZZB-q_logo>img{max-width:100%;height:auto}@container (width>=300px){.dZZB-q_logo{width:148px;height:52px}}.dZZB-q_benefit{--benefit-card-highlight-color:var(--mantine-color-primary-7);--benefit-card-text-color:var(--mantine-color-gray-7)}.dZZB-q_smartprice{--benefit-card-highlight-color:white;--benefit-card-text-color:white}.dZZB-q_cardType{--text-fz:var(--mantine-font-size-sm);--text-lh:var(--mantine-line-height-sm);color:var(--benefit-card-highlight-color);text-wrap:nowrap;font-weight:600}@container (width>=300px){.dZZB-q_cardType{--text-fz:var(--mantine-font-size-lg);--text-lh:var(--mantine-line-height-lg)}}.dZZB-q_patientName{--text-lh:var(--mantine-h5-line-height);--text-fz:var(--mantine-h5-font-size);color:var(--benefit-card-highlight-color);font-weight:600}@container (width>=260px){.dZZB-q_patientName{--text-lh:var(--mantine-h4-line-height);--text-fz:var(--mantine-h4-font-size)}}@container (width>=300px){.dZZB-q_patientName{--text-lh:var(--mantine-h2-line-height);--text-fz:var(--mantine-h2-font-size)}}.dZZB-q_fieldLabel{--text-fz:var(--mantine-font-size-sm);--text-lh:var(--mantine-line-height-sm);color:var(--benefit-card-text-color)}@container (width>=300px){.dZZB-q_fieldLabel{--text-fz:var(--mantine-font-size-md);--text-lh:var(--mantine-line-height-md)}}.dZZB-q_patientId{--text-fz:var(--mantine-font-size-sm);--text-lh:var(--mantine-line-height-sm);color:var(--benefit-card-highlight-color)}@container (width>=300px){.dZZB-q_patientId{--text-fz:var(--mantine-font-size-md);--text-lh:var(--mantine-line-height-md)}}.dZZB-q_fieldWrapper{gap:0!important}@container (width>=260px){.dZZB-q_fieldWrapper{gap:var(--mantine-spacing-xxxs)!important}}.dZZB-q_detailsValue{--text-fz:var(--mantine-font-size-sm);--text-lh:var(--mantine-line-height-sm);color:var(--benefit-card-highlight-color);font-weight:600}@container (width>=300px){.dZZB-q_detailsValue{--text-fz:var(--mantine-font-size-lg);--text-lh:var(--mantine-line-height-lg)}}");
var coverage_card_module_default = { "smartprice-card": "dZZB-q_smartprice-card", patientName: "dZZB-q_patientName", benefit: "dZZB-q_benefit", patientId: "dZZB-q_patientId", detailsWrapper: "dZZB-q_detailsWrapper", fieldWrapper: "dZZB-q_fieldWrapper", detailsValue: "dZZB-q_detailsValue", fieldLabel: "dZZB-q_fieldLabel", logo: "dZZB-q_logo", smartprice: "dZZB-q_smartprice", container: "dZZB-q_container", nameWrapper: "dZZB-q_nameWrapper", "benefit-card": "dZZB-q_benefit-card", contentWrapper: "dZZB-q_contentWrapper", cardType: "dZZB-q_cardType" };

// src/components/coverage-card/CoverageCard.tsx
import {
jsx as jsx7,
jsxs as jsxs6
} from "react/jsx-runtime";
var CoverageCard = ({
  patient,
  planInfo,
  variant
}) => {
  const { t } = useTranslation3("phx-lib");
  const cardType = variant === "benefit" ? t("coverageCard.benefitPlan") : t("coverageCard.smartprice", { tm: constants.unicode.TRADEMARK });
  return /* @__PURE__ */ jsx7(Container, {
    className: `${coverage_card_module_default.container} ${coverage_card_module_default[variant]}`,
    type: "inline-size",
    children: /* @__PURE__ */ jsx7(BaseCard, {
      "data-testid": "user-card-container",
      withBorder: true,
      p: 0,
      variant: "filled",
      radius: "sm",
      className: coverage_card_module_default[`${variant}-card`],
      children: /* @__PURE__ */ jsxs6(Stack6, {
        gap: 0,
        children: [
          /* @__PURE__ */ jsxs6(Flex4, {
            gap: "sm",
            align: "center",
            justify: "space-between",
            children: [
              /* @__PURE__ */ jsx7(Flex4, {
                bg: "primary",
                align: "center",
                className: coverage_card_module_default.logo,
                children: /* @__PURE__ */ jsx7("img", {
                  src: "/static/libraries/myphx-lib/logos/prescryptive-logo-white-text.svg",
                  alt: t("coverageCard.imageAlt.prescryptivelogo")
                })
              }),
              /* @__PURE__ */ jsx7(Box, {
                p: "0 1rem",
                children: /* @__PURE__ */ jsx7(Text, {
                  className: coverage_card_module_default.cardType,
                  children: cardType
                })
              })
            ]
          }),
          /* @__PURE__ */ jsxs6(Stack6, {
            classNames: { root: coverage_card_module_default.contentWrapper },
            flex: "1",
            children: [
              /* @__PURE__ */ jsxs6(Stack6, {
                classNames: { root: coverage_card_module_default.nameWrapper },
                "data-testid": "patient-name-container",
                children: [
                  /* @__PURE__ */ jsx7(Text, {
                    className: coverage_card_module_default.patientName,
                    children: patient.name
                  }),
                  /* @__PURE__ */ jsxs6(Flex4, {
                    gap: "sm",
                    children: [
                      /* @__PURE__ */ jsx7(Text, {
                        className: coverage_card_module_default.fieldLabel,
                        children: "ID"
                      }),
                      /* @__PURE__ */ jsx7(Text, {
                        className: coverage_card_module_default.patientId,
                        children: patient.id
                      })
                    ]
                  })
                ]
              }),
              /* @__PURE__ */ jsxs6(Flex4, {
                classNames: { root: coverage_card_module_default.detailsWrapper },
                children: [
                  /* @__PURE__ */ jsxs6(Stack6, {
                    classNames: { root: coverage_card_module_default.fieldWrapper },
                    "data-testid": "group-container",
                    children: [
                      /* @__PURE__ */ jsx7(Text, {
                        className: coverage_card_module_default.fieldLabel,
                        children: "Group"
                      }),
                      /* @__PURE__ */ jsx7(Text, {
                        className: coverage_card_module_default.detailsValue,
                        children: planInfo.group
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsxs6(Stack6, {
                    classNames: { root: coverage_card_module_default.fieldWrapper },
                    "data-testid": "bin-container",
                    children: [
                      /* @__PURE__ */ jsx7(Text, {
                        className: coverage_card_module_default.fieldLabel,
                        children: "BIN"
                      }),
                      /* @__PURE__ */ jsx7(Text, {
                        className: coverage_card_module_default.detailsValue,
                        children: planInfo.bin
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsxs6(Stack6, {
                    classNames: { root: coverage_card_module_default.fieldWrapper },
                    "data-testid": "pcn-container",
                    children: [
                      /* @__PURE__ */ jsx7(Text, {
                        className: coverage_card_module_default.fieldLabel,
                        children: "PCN"
                      }),
                      /* @__PURE__ */ jsx7(Text, {
                        className: coverage_card_module_default.detailsValue,
                        children: planInfo.pcn
                      })
                    ]
                  })
                ]
              })
            ]
          })
        ]
      })
    })
  });
};

// src/components/dependent-item/DependentItem.tsx
import {
Avatar,
Caption,
Flex as Flex6,
Space,
Stack as Stack7,
Subtitle2 as Subtitle23
} from "@phx/design-system";
import {getInitials} from "@phx/design-system/framework";

// src/components/dependent-item/DependentItemBody.tsx
import {
Body1 as Body14,
Flex as Flex5,
PhoneNumber
} from "@phx/design-system";
import {
jsx as jsx8
} from "react/jsx-runtime";
var DependentItemBody = (props) => {
  if (props.kind === "phone") {
    return /* @__PURE__ */ jsx8(PhoneNumber, {
      ...props,
      showIcon: false
    });
  }
  if (props.kind === "generic") {
    const content = typeof props.content === "string" ? /* @__PURE__ */ jsx8(Body14, {
      children: props.content
    }) : props.content;
    return /* @__PURE__ */ jsx8(Flex5, {
      gap: "xxxs",
      children: content
    });
  }
};

// src/components/dependent-item/DependentItem.tsx
import {
jsx as jsx9,
jsxs as jsxs7
} from "react/jsx-runtime";
var DependentItem = ({
  name,
  description,
  bodyItems = []
}) => {
  const body = bodyItems.map((itemProps, idx) => /* @__PURE__ */ jsx9(DependentItemBody, {
    ...itemProps
  }, `dependent-item-body-${idx}`));
  return /* @__PURE__ */ jsxs7(Flex6, {
    gap: "xs",
    children: [
      /* @__PURE__ */ jsx9(Avatar, {
        initials: getInitials(name),
        color: "primary"
      }),
      /* @__PURE__ */ jsxs7(Stack7, {
        align: "flex-start",
        gap: 0,
        children: [
          /* @__PURE__ */ jsx9(Flex6, {
            gap: "xs",
            align: "baseline",
            children: /* @__PURE__ */ jsx9(Subtitle23, {
              children: name
            })
          }),
          /* @__PURE__ */ jsx9(Caption, {
            children: description
          }),
          /* @__PURE__ */ jsx9(Space, {
            h: "xs"
          }),
          body
        ]
      })
    ]
  });
};

// src/components/illustration/variants/AddHomeIllustration.tsx
import {useTranslation as useTranslation4} from "react-i18next";

// src/components/illustration/Illustration.tsx
import {rem} from "@phx/design-system/framework";
import {
jsx as jsx10
} from "react/jsx-runtime";
var ILLUSTRATION_SIZE = {
  icon: rem("24px"),
  xs: rem("80px"),
  sm: rem("100px"),
  md: rem("120px"),
  lg: rem("140px"),
  xl: rem("200px")
};
var Illustration = ({
  alt,
  svgFile,
  size = "lg"
}) => {
  const svgSize = ILLUSTRATION_SIZE[size];
  return /* @__PURE__ */ jsx10("img", {
    src: `/static/libraries/myphx-lib/illustrations/${svgFile}`,
    "aria-label": alt,
    style: {
      height: svgSize,
      width: svgSize
    },
    "data-testid": "illustration"
  });
};

// src/components/illustration/variants/AddHomeIllustration.tsx
import {
jsx as jsx11
} from "react/jsx-runtime";
var AddHomeIllustration = (props) => {
  const { t } = useTranslation4("phx-lib");
  return /* @__PURE__ */ jsx11(Illustration, {
    ...props,
    svgFile: "add-home.svg",
    alt: t("illustration.imageAlt.addHomeIllustration")
  });
};
// src/components/illustration/variants/AdherenceAddressedIllustration.tsx
import {useTranslation as useTranslation5} from "react-i18next";
import {
jsx as jsx12
} from "react/jsx-runtime";
var AdherenceAddressedIllustration = (props) => {
  const { t } = useTranslation5("phx-lib");
  return /* @__PURE__ */ jsx12(Illustration, {
    ...props,
    svgFile: "adherence-addressed.svg",
    alt: t("illustration.imageAlt.adherenceAddressedIllustration")
  });
};
// src/components/illustration/variants/AIDrivenIllustration.tsx
import {useTranslation as useTranslation6} from "react-i18next";
import {
jsx as jsx13
} from "react/jsx-runtime";
var AIDrivenIllustration = (props) => {
  const { t } = useTranslation6("phx-lib");
  return /* @__PURE__ */ jsx13(Illustration, {
    ...props,
    svgFile: "ai-driven.svg",
    alt: t("illustration.imageAlt.aIDrivenIllustration")
  });
};
// src/components/illustration/variants/AnalyticsIllustration.tsx
import {useTranslation as useTranslation7} from "react-i18next";
import {
jsx as jsx14
} from "react/jsx-runtime";
var AnalyticsIllustration = (props) => {
  const { t } = useTranslation7("phx-lib");
  return /* @__PURE__ */ jsx14(Illustration, {
    ...props,
    svgFile: "analytics.svg",
    alt: t("illustration.imageAlt.analyticsIllustration")
  });
};
// src/components/illustration/variants/AvatarIllustration.tsx
import {useTranslation as useTranslation8} from "react-i18next";
import {
jsx as jsx15
} from "react/jsx-runtime";
var AvatarIllustration = (props) => {
  const { t } = useTranslation8("phx-lib");
  return /* @__PURE__ */ jsx15(Illustration, {
    ...props,
    svgFile: "avatar.svg",
    alt: t("illustration.imageAlt.avatar")
  });
};
// src/components/illustration/variants/BIllustration.tsx
import {useTranslation as useTranslation9} from "react-i18next";
import {
jsx as jsx16
} from "react/jsx-runtime";
var BIllustration = (props) => {
  const { t } = useTranslation9("phx-lib");
  return /* @__PURE__ */ jsx16(Illustration, {
    ...props,
    svgFile: "b.svg",
    alt: t("illustration.imageAlt.letterB")
  });
};
// src/components/illustration/variants/BikeIllustration.tsx
import {useTranslation as useTranslation10} from "react-i18next";
import {
jsx as jsx17
} from "react/jsx-runtime";
var BikeIllustration = (props) => {
  const { t } = useTranslation10("phx-lib");
  return /* @__PURE__ */ jsx17(Illustration, {
    ...props,
    svgFile: "bike.svg",
    alt: t("illustration.imageAlt.bike")
  });
};
// src/components/illustration/variants/BoardIllustration.tsx
import {useTranslation as useTranslation11} from "react-i18next";
import {
jsx as jsx18
} from "react/jsx-runtime";
var BoardIllustration = (props) => {
  const { t } = useTranslation11("phx-lib");
  return /* @__PURE__ */ jsx18(Illustration, {
    ...props,
    svgFile: "board.svg",
    alt: t("illustration.imageAlt.medicalNotepad")
  });
};
// src/components/illustration/variants/BottleAndCapsulesIllustration.tsx
import {useTranslation as useTranslation12} from "react-i18next";
import {
jsx as jsx19
} from "react/jsx-runtime";
var BottleAndCapsulesIllustration = (props) => {
  const { t } = useTranslation12("phx-lib");
  return /* @__PURE__ */ jsx19(Illustration, {
    ...props,
    svgFile: "bottle-and-capsules.svg",
    alt: t("illustration.imageAlt.bottleAndCapsules")
  });
};
// src/components/illustration/variants/BottleAndPillsIllustration.tsx
import {useTranslation as useTranslation13} from "react-i18next";
import {
jsx as jsx20
} from "react/jsx-runtime";
var BottleAndPillsIllustration = (props) => {
  const { t } = useTranslation13("phx-lib");
  return /* @__PURE__ */ jsx20(Illustration, {
    ...props,
    svgFile: "bottle-and-pills.svg",
    alt: t("illustration.imageAlt.bottleAndPills")
  });
};
// src/components/illustration/variants/BoxIllustration.tsx
import {useTranslation as useTranslation14} from "react-i18next";
import {
jsx as jsx21
} from "react/jsx-runtime";
var BoxIllustration = (props) => {
  const { t } = useTranslation14("phx-lib");
  return /* @__PURE__ */ jsx21(Illustration, {
    ...props,
    svgFile: "box.svg",
    alt: t("illustration.imageAlt.deliveryBox")
  });
};
// src/components/illustration/variants/BrainIllustration.tsx
import {useTranslation as useTranslation15} from "react-i18next";
import {
jsx as jsx22
} from "react/jsx-runtime";
var BrainIllustration = (props) => {
  const { t } = useTranslation15("phx-lib");
  return /* @__PURE__ */ jsx22(Illustration, {
    ...props,
    svgFile: "brain.svg",
    alt: t("illustration.imageAlt.brain")
  });
};
// src/components/illustration/variants/CalculatorIllustration.tsx
import {useTranslation as useTranslation16} from "react-i18next";
import {
jsx as jsx23
} from "react/jsx-runtime";
var CalculatorIllustration = (props) => {
  const { t } = useTranslation16("phx-lib");
  return /* @__PURE__ */ jsx23(Illustration, {
    ...props,
    svgFile: "calculator.svg",
    alt: t("illustration.imageAlt.calculator")
  });
};
// src/components/illustration/variants/CalendarIllustration.tsx
import {useTranslation as useTranslation17} from "react-i18next";
import {
jsx as jsx24
} from "react/jsx-runtime";
var CalendarIllustration = (props) => {
  const { t } = useTranslation17("phx-lib");
  return /* @__PURE__ */ jsx24(Illustration, {
    ...props,
    svgFile: "calendar.svg",
    alt: t("illustration.imageAlt.calendar")
  });
};
// src/components/illustration/variants/CardIllustration.tsx
import {useTranslation as useTranslation18} from "react-i18next";
import {
jsx as jsx25
} from "react/jsx-runtime";
var CardIllustration = (props) => {
  const { t } = useTranslation18("phx-lib");
  return /* @__PURE__ */ jsx25(Illustration, {
    ...props,
    svgFile: "card.svg",
    alt: t("illustration.imageAlt.card")
  });
};
// src/components/illustration/variants/ChecklistIllustration.tsx
import {useTranslation as useTranslation19} from "react-i18next";
import {
jsx as jsx26
} from "react/jsx-runtime";
var ChecklistIllustration = (props) => {
  const { t } = useTranslation19("phx-lib");
  return /* @__PURE__ */ jsx26(Illustration, {
    ...props,
    svgFile: "checklist.svg",
    alt: t("illustration.imageAlt.checklistNotepad")
  });
};
// src/components/illustration/variants/ClaimDeniedIllustration.tsx
import {useTranslation as useTranslation20} from "react-i18next";
import {
jsx as jsx27
} from "react/jsx-runtime";
var ClaimDeniedIllustration = (props) => {
  const { t } = useTranslation20("phx-lib");
  return /* @__PURE__ */ jsx27(Illustration, {
    ...props,
    svgFile: "claim-denied.svg",
    alt: t("illustration.imageAlt.claimDenied")
  });
};
// src/components/illustration/variants/CloudIllustration.tsx
import {useTranslation as useTranslation21} from "react-i18next";
import {
jsx as jsx28
} from "react/jsx-runtime";
var CloudIllustration = (props) => {
  const { t } = useTranslation21("phx-lib");
  return /* @__PURE__ */ jsx28(Illustration, {
    ...props,
    svgFile: "cloud.svg",
    alt: t("illustration.imageAlt.cloud")
  });
};
// src/components/illustration/variants/CoinIllustration.tsx
import {useTranslation as useTranslation22} from "react-i18next";
import {
jsx as jsx29
} from "react/jsx-runtime";
var CoinIllustration = (props) => {
  const { t } = useTranslation22("phx-lib");
  return /* @__PURE__ */ jsx29(Illustration, {
    ...props,
    svgFile: "coin.svg",
    alt: t("illustration.imageAlt.coin")
  });
};
// src/components/illustration/variants/ComparePricesIllustration.tsx
import {useTranslation as useTranslation23} from "react-i18next";
import {
jsx as jsx30
} from "react/jsx-runtime";
var ComparePricesIllustration = (props) => {
  const { t } = useTranslation23("phx-lib");
  return /* @__PURE__ */ jsx30(Illustration, {
    ...props,
    svgFile: "compare-prices.svg",
    alt: t("illustration.imageAlt.comparePrices")
  });
};
// src/components/illustration/variants/ConferenceIllustration.tsx
import {useTranslation as useTranslation24} from "react-i18next";
import {
jsx as jsx31
} from "react/jsx-runtime";
var ConferenceIllustration = (props) => {
  const { t } = useTranslation24("phx-lib");
  return /* @__PURE__ */ jsx31(Illustration, {
    ...props,
    svgFile: "conference.svg",
    alt: t("illustration.imageAlt.peopleForum")
  });
};
// src/components/illustration/variants/ConsumersIllustration.tsx
import {useTranslation as useTranslation25} from "react-i18next";
import {
jsx as jsx32
} from "react/jsx-runtime";
var ConsumersIllustration = (props) => {
  const { t } = useTranslation25("phx-lib");
  return /* @__PURE__ */ jsx32(Illustration, {
    ...props,
    svgFile: "consumers.svg",
    alt: t("illustration.imageAlt.consumers")
  });
};
// src/components/illustration/variants/ContactBookIllustration.tsx
import {useTranslation as useTranslation26} from "react-i18next";
import {
jsx as jsx33
} from "react/jsx-runtime";
var ContactBookIllustration = (props) => {
  const { t } = useTranslation26("phx-lib");
  return /* @__PURE__ */ jsx33(Illustration, {
    ...props,
    svgFile: "contact-book.svg",
    alt: t("illustration.imageAlt.contactBook")
  });
};
// src/components/illustration/variants/DatabaseIllustration.tsx
import {useTranslation as useTranslation27} from "react-i18next";
import {
jsx as jsx34
} from "react/jsx-runtime";
var DatabaseIllustration = (props) => {
  const { t } = useTranslation27("phx-lib");
  return /* @__PURE__ */ jsx34(Illustration, {
    ...props,
    svgFile: "database.svg",
    alt: t("illustration.imageAlt.database")
  });
};
// src/components/illustration/variants/DirectEngagementIllustration.tsx
import {useTranslation as useTranslation28} from "react-i18next";
import {
jsx as jsx35
} from "react/jsx-runtime";
var DirectEngagementIllustration = (props) => {
  const { t } = useTranslation28("phx-lib");
  return /* @__PURE__ */ jsx35(Illustration, {
    ...props,
    svgFile: "direct-engagement.svg",
    alt: t("illustration.imageAlt.engagement")
  });
};
// src/components/illustration/variants/DirectionsIllustration.tsx
import {useTranslation as useTranslation29} from "react-i18next";
import {
jsx as jsx36
} from "react/jsx-runtime";
var DirectionsIllustration = (props) => {
  const { t } = useTranslation29("phx-lib");
  return /* @__PURE__ */ jsx36(Illustration, {
    ...props,
    svgFile: "directions.svg",
    alt: t("illustration.imageAlt.directions")
  });
};
// src/components/illustration/variants/DocumentsIllustration.tsx
import {useTranslation as useTranslation30} from "react-i18next";
import {
jsx as jsx37
} from "react/jsx-runtime";
var DocumentsIllustration = (props) => {
  const { t } = useTranslation30("phx-lib");
  return /* @__PURE__ */ jsx37(Illustration, {
    ...props,
    svgFile: "documents.svg",
    alt: t("illustration.imageAlt.documentFolder")
  });
};
// src/components/illustration/variants/EasyToUseIllustration.tsx
import {useTranslation as useTranslation31} from "react-i18next";
import {
jsx as jsx38
} from "react/jsx-runtime";
var EasyToUseIllustration = (props) => {
  const { t } = useTranslation31("phx-lib");
  return /* @__PURE__ */ jsx38(Illustration, {
    ...props,
    svgFile: "easy-to-use.svg",
    alt: t("illustration.imageAlt.easyToUse")
  });
};
// src/components/illustration/variants/EmployersAndConsultantsIllustration.tsx
import {useTranslation as useTranslation32} from "react-i18next";
import {
jsx as jsx39
} from "react/jsx-runtime";
var EmployersAndConsultantsIllustration = (props) => {
  const { t } = useTranslation32("phx-lib");
  return /* @__PURE__ */ jsx39(Illustration, {
    ...props,
    svgFile: "employers-and-consultants.svg",
    alt: t("illustration.imageAlt.businessBuilding")
  });
};
// src/components/illustration/variants/EmptyCabinetIllustration.tsx
import {useTranslation as useTranslation33} from "react-i18next";
import {
jsx as jsx40
} from "react/jsx-runtime";
var EmptyCabinetIllustration = (props) => {
  const { t } = useTranslation33("phx-lib");
  return /* @__PURE__ */ jsx40(Illustration, {
    ...props,
    svgFile: "empty-cabinet.svg",
    alt: t("illustration.imageAlt.emptyCabinet")
  });
};
// src/components/illustration/variants/Error404Illustration.tsx
import {useTranslation as useTranslation34} from "react-i18next";
import {
jsx as jsx41
} from "react/jsx-runtime";
var Error404Illustration = (props) => {
  const { t } = useTranslation34("phx-lib");
  return /* @__PURE__ */ jsx41(Illustration, {
    ...props,
    svgFile: "error404.svg",
    alt: t("illustration.imageAlt.error404")
  });
};
// src/components/illustration/variants/FamilyIllustration.tsx
import {useTranslation as useTranslation35} from "react-i18next";
import {
jsx as jsx42
} from "react/jsx-runtime";
var FamilyIllustration = (props) => {
  const { t } = useTranslation35("phx-lib");
  return /* @__PURE__ */ jsx42(Illustration, {
    ...props,
    svgFile: "family.svg",
    alt: t("illustration.imageAlt.family")
  });
};
// src/components/illustration/variants/FemaleDoctorIllustration.tsx
import {useTranslation as useTranslation36} from "react-i18next";
import {
jsx as jsx43
} from "react/jsx-runtime";
var FemaleDoctorIllustration = (props) => {
  const { t } = useTranslation36("phx-lib");
  return /* @__PURE__ */ jsx43(Illustration, {
    ...props,
    svgFile: "female-doctor.svg",
    alt: t("illustration.imageAlt.femaleDoctor")
  });
};
// src/components/illustration/variants/FemaleUserIllustration.tsx
import {useTranslation as useTranslation37} from "react-i18next";
import {
jsx as jsx44
} from "react/jsx-runtime";
var FemaleUserIllustration = (props) => {
  const { t } = useTranslation37("phx-lib");
  return /* @__PURE__ */ jsx44(Illustration, {
    ...props,
    svgFile: "female-user.svg",
    alt: t("illustration.imageAlt.femaleUser")
  });
};
// src/components/illustration/variants/FirstAidKitIllustration.tsx
import {useTranslation as useTranslation38} from "react-i18next";
import {
jsx as jsx45
} from "react/jsx-runtime";
var FirstAidKitIllustration = (props) => {
  const { t } = useTranslation38("phx-lib");
  return /* @__PURE__ */ jsx45(Illustration, {
    ...props,
    svgFile: "first-aid-kit.svg",
    alt: t("illustration.imageAlt.firstAidKit")
  });
};
// src/components/illustration/variants/FlexibleAlignmentIllustration.tsx
import {useTranslation as useTranslation39} from "react-i18next";
import {
jsx as jsx46
} from "react/jsx-runtime";
var FlexibleAligmentIllustration = (props) => {
  const { t } = useTranslation39("phx-lib");
  return /* @__PURE__ */ jsx46(Illustration, {
    ...props,
    svgFile: "flexible-aligment.svg",
    alt: t("illustration.imageAlt.settingsDevice")
  });
};
// src/components/illustration/variants/GearIllustration.tsx
import {useTranslation as useTranslation40} from "react-i18next";
import {
jsx as jsx47
} from "react/jsx-runtime";
var GearIllustration = (props) => {
  const { t } = useTranslation40("phx-lib");
  return /* @__PURE__ */ jsx47(Illustration, {
    ...props,
    svgFile: "gear.svg",
    alt: t("illustration.imageAlt.gear")
  });
};
// src/components/illustration/variants/GlobalConnectionIllustration.tsx
import {useTranslation as useTranslation41} from "react-i18next";
import {
jsx as jsx48
} from "react/jsx-runtime";
var GlobalConnectionIllustration = (props) => {
  const { t } = useTranslation41("phx-lib");
  return /* @__PURE__ */ jsx48(Illustration, {
    ...props,
    svgFile: "global-connection.svg",
    alt: t("illustration.imageAlt.globalConnection")
  });
};
// src/components/illustration/variants/GroupIdeaIllustration.tsx
import {useTranslation as useTranslation42} from "react-i18next";
import {
jsx as jsx49
} from "react/jsx-runtime";
var GroupIdeaIllustration = (props) => {
  const { t } = useTranslation42("phx-lib");
  return /* @__PURE__ */ jsx49(Illustration, {
    ...props,
    svgFile: "group-idea.svg",
    alt: t("illustration.imageAlt.groupIdea")
  });
};
// src/components/illustration/variants/GroupIllustration.tsx
import {useTranslation as useTranslation43} from "react-i18next";
import {
jsx as jsx50
} from "react/jsx-runtime";
var GroupIllustration = (props) => {
  const { t } = useTranslation43("phx-lib");
  return /* @__PURE__ */ jsx50(Illustration, {
    ...props,
    svgFile: "group.svg",
    alt: t("illustration.imageAlt.group")
  });
};
// src/components/illustration/variants/GrowthIllustration.tsx
import {useTranslation as useTranslation44} from "react-i18next";
import {
jsx as jsx51
} from "react/jsx-runtime";
var GrowthIllustration = (props) => {
  const { t } = useTranslation44("phx-lib");
  return /* @__PURE__ */ jsx51(Illustration, {
    ...props,
    svgFile: "growth.svg",
    alt: t("illustration.imageAlt.growth")
  });
};
// src/components/illustration/variants/HandsWithPhoneIllustration.tsx
import {useTranslation as useTranslation45} from "react-i18next";
import {
jsx as jsx52
} from "react/jsx-runtime";
var HandsWithPhoneIllustration = (props) => {
  const { t } = useTranslation45("phx-lib");
  return /* @__PURE__ */ jsx52(Illustration, {
    ...props,
    svgFile: "hands-with-phone.svg",
    alt: t("illustration.imageAlt.handWithPhone")
  });
};
// src/components/illustration/variants/HandshakeIllustration.tsx
import {useTranslation as useTranslation46} from "react-i18next";
import {
jsx as jsx53
} from "react/jsx-runtime";
var HandshakeIllustration = (props) => {
  const { t } = useTranslation46("phx-lib");
  return /* @__PURE__ */ jsx53(Illustration, {
    ...props,
    svgFile: "handshake.svg",
    alt: t("illustration.imageAlt.handshake")
  });
};
// src/components/illustration/variants/IdeaIllustration.tsx
import {useTranslation as useTranslation47} from "react-i18next";
import {
jsx as jsx54
} from "react/jsx-runtime";
var IdeaIllustration = (props) => {
  const { t } = useTranslation47("phx-lib");
  return /* @__PURE__ */ jsx54(Illustration, {
    ...props,
    svgFile: "idea.svg",
    alt: t("illustration.imageAlt.idea")
  });
};
// src/components/illustration/variants/LaptopIllustration.tsx
import {useTranslation as useTranslation48} from "react-i18next";
import {
jsx as jsx55
} from "react/jsx-runtime";
var LaptopIllustration = (props) => {
  const { t } = useTranslation48("phx-lib");
  return /* @__PURE__ */ jsx55(Illustration, {
    ...props,
    svgFile: "laptop.svg",
    alt: t("illustration.imageAlt.laptop")
  });
};
// src/components/illustration/variants/LightbulbIllustration.tsx
import {useTranslation as useTranslation49} from "react-i18next";
import {
jsx as jsx56
} from "react/jsx-runtime";
var LightbulbIllustration = (props) => {
  const { t } = useTranslation49("phx-lib");
  return /* @__PURE__ */ jsx56(Illustration, {
    ...props,
    svgFile: "lightbulb.svg",
    alt: t("illustration.imageAlt.lightbulb")
  });
};
// src/components/illustration/variants/LightingIllustration.tsx
import {useTranslation as useTranslation50} from "react-i18next";
import {
jsx as jsx57
} from "react/jsx-runtime";
var LightingIllustration = (props) => {
  const { t } = useTranslation50("phx-lib");
  return /* @__PURE__ */ jsx57(Illustration, {
    ...props,
    svgFile: "lighting.svg",
    alt: t("illustration.imageAlt.lighting")
  });
};
// src/components/illustration/variants/LocationFailedIllustration.tsx
import {useTranslation as useTranslation51} from "react-i18next";
import {
jsx as jsx58
} from "react/jsx-runtime";
var LocationFailedIllustration = (props) => {
  const { t } = useTranslation51("phx-lib");
  return /* @__PURE__ */ jsx58(Illustration, {
    ...props,
    svgFile: "location-failed.svg",
    alt: t("illustration.imageAlt.locationFailed")
  });
};
// src/components/illustration/variants/LocationIllustration.tsx
import {useTranslation as useTranslation52} from "react-i18next";
import {
jsx as jsx59
} from "react/jsx-runtime";
var LocationIllustration = (props) => {
  const { t } = useTranslation52("phx-lib");
  return /* @__PURE__ */ jsx59(Illustration, {
    ...props,
    svgFile: "location.svg",
    alt: t("illustration.imageAlt.location")
  });
};
// src/components/illustration/variants/LockIllustration.tsx
import {useTranslation as useTranslation53} from "react-i18next";
import {
jsx as jsx60
} from "react/jsx-runtime";
var LockIllustration = (props) => {
  const { t } = useTranslation53("phx-lib");
  return /* @__PURE__ */ jsx60(Illustration, {
    ...props,
    svgFile: "lock.svg",
    alt: t("illustration.imageAlt.lock")
  });
};
// src/components/illustration/variants/MagnifierAlertIllustration.tsx
import {useTranslation as useTranslation54} from "react-i18next";
import {
jsx as jsx61
} from "react/jsx-runtime";
var MagnifierAlertIllustration = (props) => {
  const { t } = useTranslation54("phx-lib");
  return /* @__PURE__ */ jsx61(Illustration, {
    ...props,
    svgFile: "magnifier-alert.svg",
    alt: t("illustration.imageAlt.magnifierAlert")
  });
};
// src/components/illustration/variants/MailOrderIllustration.tsx
import {useTranslation as useTranslation55} from "react-i18next";
import {
jsx as jsx62
} from "react/jsx-runtime";
var MailOrderIllustration = (props) => {
  const { t } = useTranslation55("phx-lib");
  return /* @__PURE__ */ jsx62(Illustration, {
    ...props,
    svgFile: "mail-order.svg",
    alt: t("illustration.imageAlt.mailOrderOnSmartphone")
  });
};
// src/components/illustration/variants/MaleUserIllustration.tsx
import {useTranslation as useTranslation56} from "react-i18next";
import {
jsx as jsx63
} from "react/jsx-runtime";
var MaleUserIllustration = (props) => {
  const { t } = useTranslation56("phx-lib");
  return /* @__PURE__ */ jsx63(Illustration, {
    ...props,
    svgFile: "male-user.svg",
    alt: t("illustration.imageAlt.maleUser")
  });
};
// src/components/illustration/variants/MedicineIllustration.tsx
import {useTranslation as useTranslation57} from "react-i18next";
import {
jsx as jsx64
} from "react/jsx-runtime";
var MedicineIllustration = (props) => {
  const { t } = useTranslation57("phx-lib");
  return /* @__PURE__ */ jsx64(Illustration, {
    ...props,
    svgFile: "medicine.svg",
    alt: t("illustration.imageAlt.medicineSymbol")
  });
};
// src/components/illustration/variants/MegaphoneIllustration.tsx
import {useTranslation as useTranslation58} from "react-i18next";
import {
jsx as jsx65
} from "react/jsx-runtime";
var MegaphoneIllustration = (props) => {
  const { t } = useTranslation58("phx-lib");
  return /* @__PURE__ */ jsx65(Illustration, {
    ...props,
    svgFile: "megaphone.svg",
    alt: t("illustration.imageAlt.megaphone")
  });
};
// src/components/illustration/variants/MemberIdIllustration.tsx
import {useTranslation as useTranslation59} from "react-i18next";
import {
jsx as jsx66
} from "react/jsx-runtime";
var MemberIdIllustration = (props) => {
  const { t } = useTranslation59("phx-lib");
  return /* @__PURE__ */ jsx66(Illustration, {
    ...props,
    svgFile: "member-id.svg",
    alt: t("illustration.imageAlt.memberId")
  });
};
// src/components/illustration/variants/MixingBowlIllustration.tsx
import {useTranslation as useTranslation60} from "react-i18next";
import {
jsx as jsx67
} from "react/jsx-runtime";
var MixingBowlIllustration = (props) => {
  const { t } = useTranslation60("phx-lib");
  return /* @__PURE__ */ jsx67(Illustration, {
    ...props,
    svgFile: "mixing-bowl.svg",
    alt: t("illustration.imageAlt.mixingBowl")
  });
};
// src/components/illustration/variants/MobileExperienceIllustration.tsx
import {useTranslation as useTranslation61} from "react-i18next";
import {
jsx as jsx68
} from "react/jsx-runtime";
var MobileExperienceIllustration = (props) => {
  const { t } = useTranslation61("phx-lib");
  return /* @__PURE__ */ jsx68(Illustration, {
    ...props,
    svgFile: "mobile-experience.svg",
    alt: t("illustration.imageAlt.mobileExperience")
  });
};
// src/components/illustration/variants/MoneyDownIllustration.tsx
import {useTranslation as useTranslation62} from "react-i18next";
import {
jsx as jsx69
} from "react/jsx-runtime";
var MoneyDownIllustration = (props) => {
  const { t } = useTranslation62("phx-lib");
  return /* @__PURE__ */ jsx69(Illustration, {
    ...props,
    svgFile: "money-down.svg",
    alt: t("illustration.imageAlt.moneyDown")
  });
};
// src/components/illustration/variants/MoneyGrowthIllustration.tsx
import {useTranslation as useTranslation63} from "react-i18next";
import {
jsx as jsx70
} from "react/jsx-runtime";
var MoneyGrowthIllustration = (props) => {
  const { t } = useTranslation63("phx-lib");
  return /* @__PURE__ */ jsx70(Illustration, {
    ...props,
    svgFile: "money-growth.svg",
    alt: t("illustration.imageAlt.moneyGrowth")
  });
};
// src/components/illustration/variants/NoClaimsIllustration.tsx
import {useTranslation as useTranslation64} from "react-i18next";
import {
jsx as jsx71
} from "react/jsx-runtime";
var NoClaimsIllustration = (props) => {
  const { t } = useTranslation64("phx-lib");
  return /* @__PURE__ */ jsx71(Illustration, {
    ...props,
    svgFile: "no-claims.svg",
    alt: t("illustration.imageAlt.noClaims")
  });
};
// src/components/illustration/variants/NoMoneyIllustration.tsx
import {useTranslation as useTranslation65} from "react-i18next";
import {
jsx as jsx72
} from "react/jsx-runtime";
var NoMoneyIllustration = (props) => {
  const { t } = useTranslation65("phx-lib");
  return /* @__PURE__ */ jsx72(Illustration, {
    ...props,
    svgFile: "no-money.svg",
    alt: t("illustration.imageAlt.noMoney")
  });
};
// src/components/illustration/variants/NoPillsIllustration.tsx
import {useTranslation as useTranslation66} from "react-i18next";
import {
jsx as jsx73
} from "react/jsx-runtime";
var NoPillsIllustration = (props) => {
  const { t } = useTranslation66("phx-lib");
  return /* @__PURE__ */ jsx73(Illustration, {
    ...props,
    svgFile: "no-pills.svg",
    alt: t("illustration.imageAlt.noPills")
  });
};
// src/components/illustration/variants/NoResultsIllustration.tsx
import {useTranslation as useTranslation67} from "react-i18next";
import {
jsx as jsx74
} from "react/jsx-runtime";
var NoResultsIllustration = (props) => {
  const { t } = useTranslation67("phx-lib");
  return /* @__PURE__ */ jsx74(Illustration, {
    ...props,
    svgFile: "no-results.svg",
    alt: t("illustration.imageAlt.noResults")
  });
};
// src/components/illustration/variants/NotepadIllustration.tsx
import {useTranslation as useTranslation68} from "react-i18next";
import {
jsx as jsx75
} from "react/jsx-runtime";
var NotepadIllustration = (props) => {
  const { t } = useTranslation68("phx-lib");
  return /* @__PURE__ */ jsx75(Illustration, {
    ...props,
    svgFile: "notepad.svg",
    alt: t("illustration.imageAlt.notepad")
  });
};
// src/components/illustration/variants/NutritionalBoardIllustration.tsx
import {useTranslation as useTranslation69} from "react-i18next";
import {
jsx as jsx76
} from "react/jsx-runtime";
var NutritionalBoardIllustration = (props) => {
  const { t } = useTranslation69("phx-lib");
  return /* @__PURE__ */ jsx76(Illustration, {
    ...props,
    svgFile: "nutritional-board.svg",
    alt: t("illustration.imageAlt.nutritionalNotepad")
  });
};
// src/components/illustration/variants/PharmaIllustration.tsx
import {useTranslation as useTranslation70} from "react-i18next";
import {
jsx as jsx77
} from "react/jsx-runtime";
var PharmaIllustration = (props) => {
  const { t } = useTranslation70("phx-lib");
  return /* @__PURE__ */ jsx77(Illustration, {
    ...props,
    svgFile: "pharma.svg",
    alt: t("illustration.imageAlt.microscope")
  });
};
// src/components/illustration/variants/PharmacyIllustration.tsx
import {useTranslation as useTranslation71} from "react-i18next";
import {
jsx as jsx78
} from "react/jsx-runtime";
var PharmacyIllustration = (props) => {
  const { t } = useTranslation71("phx-lib");
  return /* @__PURE__ */ jsx78(Illustration, {
    ...props,
    svgFile: "pharmacy.svg",
    alt: t("illustration.imageAlt.pharmacy")
  });
};
// src/components/illustration/variants/PiggybankIllustration.tsx
import {useTranslation as useTranslation72} from "react-i18next";
import {
jsx as jsx79
} from "react/jsx-runtime";
var PiggybankIllustration = (props) => {
  const { t } = useTranslation72("phx-lib");
  return /* @__PURE__ */ jsx79(Illustration, {
    ...props,
    svgFile: "piggybank.svg",
    alt: t("illustration.imageAlt.piggybank")
  });
};
// src/components/illustration/variants/PillsIllustration.tsx
import {useTranslation as useTranslation73} from "react-i18next";
import {
jsx as jsx80
} from "react/jsx-runtime";
var PillsIllustration = (props) => {
  const { t } = useTranslation73("phx-lib");
  return /* @__PURE__ */ jsx80(Illustration, {
    ...props,
    svgFile: "pills.svg",
    alt: t("illustration.imageAlt.pills")
  });
};
// src/components/illustration/variants/PredictiveModelIllustration.tsx
import {useTranslation as useTranslation74} from "react-i18next";
import {
jsx as jsx81
} from "react/jsx-runtime";
var PredictiveModelIllustration = (props) => {
  const { t } = useTranslation74("phx-lib");
  return /* @__PURE__ */ jsx81(Illustration, {
    ...props,
    svgFile: "predictive-model.svg",
    alt: t("illustration.imageAlt.predictiveModel")
  });
};
// src/components/illustration/variants/PrescriptionIllustration.tsx
import {useTranslation as useTranslation75} from "react-i18next";
import {
jsx as jsx82
} from "react/jsx-runtime";
var PrescriptionIllustration = (props) => {
  const { t } = useTranslation75("phx-lib");
  return /* @__PURE__ */ jsx82(Illustration, {
    ...props,
    svgFile: "prescription.svg",
    alt: t("illustration.imageAlt.prescriptionPaper")
  });
};
// src/components/illustration/variants/ProtectionIllustration.tsx
import {useTranslation as useTranslation76} from "react-i18next";
import {
jsx as jsx83
} from "react/jsx-runtime";
var ProtectionIllustration = (props) => {
  const { t } = useTranslation76("phx-lib");
  return /* @__PURE__ */ jsx83(Illustration, {
    ...props,
    svgFile: "protection.svg",
    alt: t("illustration.imageAlt.shield")
  });
};
// src/components/illustration/variants/ReportsIllustration.tsx
import {useTranslation as useTranslation77} from "react-i18next";
import {
jsx as jsx84
} from "react/jsx-runtime";
var ReportsIllustration = (props) => {
  const { t } = useTranslation77("phx-lib");
  return /* @__PURE__ */ jsx84(Illustration, {
    ...props,
    svgFile: "reports.svg",
    alt: t("illustration.imageAlt.reports")
  });
};
// src/components/illustration/variants/LabSampleIllustration.tsx
import {useTranslation as useTranslation78} from "react-i18next";
import {
jsx as jsx85
} from "react/jsx-runtime";
var LabSampleIllustration = (props) => {
  const { t } = useTranslation78("phx-lib");
  return /* @__PURE__ */ jsx85(Illustration, {
    ...props,
    svgFile: "lab-sample.svg",
    alt: t("illustration.imageAlt.labSample")
  });
};
// src/components/illustration/variants/SaveMoneyIllustration.tsx
import {useTranslation as useTranslation79} from "react-i18next";
import {
jsx as jsx86
} from "react/jsx-runtime";
var SaveMoneyIllustration = (props) => {
  const { t } = useTranslation79("phx-lib");
  return /* @__PURE__ */ jsx86(Illustration, {
    ...props,
    svgFile: "save-money.svg",
    alt: t("illustration.imageAlt.wallet")
  });
};
// src/components/illustration/variants/ShieldIllustration.tsx
import {useTranslation as useTranslation80} from "react-i18next";
import {
jsx as jsx87
} from "react/jsx-runtime";
var ShieldIllustration = (props) => {
  const { t } = useTranslation80("phx-lib");
  return /* @__PURE__ */ jsx87(Illustration, {
    ...props,
    svgFile: "shield.svg",
    alt: t("illustration.imageAlt.dataSecurity")
  });
};
// src/components/illustration/variants/ShoppingBagIllustration.tsx
import {useTranslation as useTranslation81} from "react-i18next";
import {
jsx as jsx88
} from "react/jsx-runtime";
var ShoppingBagIllustration = (props) => {
  const { t } = useTranslation81("phx-lib");
  return /* @__PURE__ */ jsx88(Illustration, {
    ...props,
    svgFile: "shopping-bag.svg",
    alt: t("illustration.imageAlt.shoppingBag")
  });
};
// src/components/illustration/variants/ShoppingCartIllustration.tsx
import {useTranslation as useTranslation82} from "react-i18next";
import {
jsx as jsx89
} from "react/jsx-runtime";
var ShoppingCartIllustration = (props) => {
  const { t } = useTranslation82("phx-lib");
  return /* @__PURE__ */ jsx89(Illustration, {
    ...props,
    svgFile: "shopping-cart.svg",
    alt: t("illustration.imageAlt.shoppingCart")
  });
};
// src/components/illustration/variants/SmartphoneIllustration.tsx
import {useTranslation as useTranslation83} from "react-i18next";
import {
jsx as jsx90
} from "react/jsx-runtime";
var SmartphoneIllustration = (props) => {
  const { t } = useTranslation83("phx-lib");
  return /* @__PURE__ */ jsx90(Illustration, {
    ...props,
    svgFile: "smartphone.svg",
    alt: t("illustration.imageAlt.smartphone")
  });
};
// src/components/illustration/variants/StethoscopeIllustration.tsx
import {useTranslation as useTranslation84} from "react-i18next";
import {
jsx as jsx91
} from "react/jsx-runtime";
var StethoscopeIllustration = (props) => {
  const { t } = useTranslation84("phx-lib");
  return /* @__PURE__ */ jsx91(Illustration, {
    ...props,
    svgFile: "stethoscope.svg",
    alt: t("illustration.imageAlt.stethoscope")
  });
};
// src/components/illustration/variants/SwitchMedicinesIllustration.tsx
import {useTranslation as useTranslation85} from "react-i18next";
import {
jsx as jsx92
} from "react/jsx-runtime";
var SwitchMedicinesIllustration = (props) => {
  const { t } = useTranslation85("phx-lib");
  return /* @__PURE__ */ jsx92(Illustration, {
    ...props,
    svgFile: "switch-medicines.svg",
    alt: t("illustration.imageAlt.switchMedications")
  });
};
// src/components/illustration/variants/TestTubeIllustration.tsx
import {useTranslation as useTranslation86} from "react-i18next";
import {
jsx as jsx93
} from "react/jsx-runtime";
var TestTubesIllustration = (props) => {
  const { t } = useTranslation86("phx-lib");
  return /* @__PURE__ */ jsx93(Illustration, {
    ...props,
    svgFile: "test-tubes.svg",
    alt: t("illustration.imageAlt.testTubes")
  });
};
// src/components/illustration/variants/TextReceivedIllustration.tsx
import {useTranslation as useTranslation87} from "react-i18next";
import {
jsx as jsx94
} from "react/jsx-runtime";
var TextReceivedIllustration = (props) => {
  const { t } = useTranslation87("phx-lib");
  return /* @__PURE__ */ jsx94(Illustration, {
    ...props,
    svgFile: "text-received.svg",
    alt: t("illustration.imageAlt.textBubble")
  });
};
// src/components/illustration/variants/TextUpdatesIllustration.tsx
import {useTranslation as useTranslation88} from "react-i18next";
import {
jsx as jsx95
} from "react/jsx-runtime";
var TextUpdatesIllustration = (props) => {
  const { t } = useTranslation88("phx-lib");
  return /* @__PURE__ */ jsx95(Illustration, {
    ...props,
    svgFile: "text-updates.svg",
    alt: t("illustration.imageAlt.textUpdates")
  });
};
// src/components/illustration/variants/TimeExpiredIllustration.tsx
import {useTranslation as useTranslation89} from "react-i18next";
import {
jsx as jsx96
} from "react/jsx-runtime";
var TimeExpiredIllustration = (props) => {
  const { t } = useTranslation89("phx-lib");
  return /* @__PURE__ */ jsx96(Illustration, {
    ...props,
    svgFile: "time-expired.svg",
    alt: t("illustration.imageAlt.expiredTime")
  });
};
// src/components/illustration/variants/TransferFailedIllustration.tsx
import {useTranslation as useTranslation90} from "react-i18next";
import {
jsx as jsx97
} from "react/jsx-runtime";
var TransferFailedIllustration = (props) => {
  const { t } = useTranslation90("phx-lib");
  return /* @__PURE__ */ jsx97(Illustration, {
    ...props,
    svgFile: "transfer-failed.svg",
    alt: t("illustration.imageAlt.transferFailed")
  });
};
// src/components/illustration/variants/TransparencyIllustration.tsx
import {useTranslation as useTranslation91} from "react-i18next";
import {
jsx as jsx98
} from "react/jsx-runtime";
var TransparencyIllustration = (props) => {
  const { t } = useTranslation91("phx-lib");
  return /* @__PURE__ */ jsx98(Illustration, {
    ...props,
    svgFile: "transparency.svg",
    alt: t("illustration.imageAlt.magnifierGlass")
  });
};
// src/components/illustration/variants/TransportIllustration.tsx
import {useTranslation as useTranslation92} from "react-i18next";
import {
jsx as jsx99
} from "react/jsx-runtime";
var TransportIllustration = (props) => {
  const { t } = useTranslation92("phx-lib");
  return /* @__PURE__ */ jsx99(Illustration, {
    ...props,
    svgFile: "transport.svg",
    alt: t("illustration.imageAlt.deliveryVan")
  });
};
// src/components/illustration/variants/TwentyFourHoursIllustration.tsx
import {useTranslation as useTranslation93} from "react-i18next";
import {
jsx as jsx100
} from "react/jsx-runtime";
var TwentyFourHoursIllustration = (props) => {
  const { t } = useTranslation93("phx-lib");
  return /* @__PURE__ */ jsx100(Illustration, {
    ...props,
    svgFile: "twenty-four-hours.svg",
    alt: t("illustration.imageAlt.twentyFourHours")
  });
};
// src/components/illustration/variants/UnderMaintenanceIllustration.tsx
import {useTranslation as useTranslation94} from "react-i18next";
import {
jsx as jsx101
} from "react/jsx-runtime";
var UnderMaintenanceIllustration = (props) => {
  const { t } = useTranslation94("phx-lib");
  return /* @__PURE__ */ jsx101(Illustration, {
    ...props,
    svgFile: "under-maintenance.svg",
    alt: t("illustration.imageAlt.maintenance")
  });
};
// src/components/illustration/variants/UnexpectedErrorIllustration.tsx
import {useTranslation as useTranslation95} from "react-i18next";
import {
jsx as jsx102
} from "react/jsx-runtime";
var UnexpectedErrorIllustration = (props) => {
  const { t } = useTranslation95("phx-lib");
  return /* @__PURE__ */ jsx102(Illustration, {
    ...props,
    svgFile: "unexpected-error.svg",
    alt: t("illustration.imageAlt.unexpectedError")
  });
};
// src/components/illustration/variants/UpToDateIllustration.tsx
import {useTranslation as useTranslation96} from "react-i18next";
import {
jsx as jsx103
} from "react/jsx-runtime";
var UpToDateIllustration = (props) => {
  const { t } = useTranslation96("phx-lib");
  return /* @__PURE__ */ jsx103(Illustration, {
    ...props,
    svgFile: "up-to-date.svg",
    alt: t("illustration.imageAlt.upToDate")
  });
};
// src/components/illustration/variants/VaccineIllustration.tsx
import {useTranslation as useTranslation97} from "react-i18next";
import {
jsx as jsx104
} from "react/jsx-runtime";
var VaccineIllustration = (props) => {
  const { t } = useTranslation97("phx-lib");
  return /* @__PURE__ */ jsx104(Illustration, {
    ...props,
    svgFile: "vaccine.svg",
    alt: t("illustration.imageAlt.vaccine")
  });
};
// src/components/illustration/variants/ZeroFeesIllustration.tsx
import {useTranslation as useTranslation98} from "react-i18next";
import {
jsx as jsx105
} from "react/jsx-runtime";
var ZeroFeesIllustration = (props) => {
  const { t } = useTranslation98("phx-lib");
  return /* @__PURE__ */ jsx105(Illustration, {
    ...props,
    svgFile: "zero-fees.svg",
    alt: t("illustration.imageAlt.zeroFees")
  });
};
// src/components/illustration-card/IllustrationCard.tsx
import {
BareCard,
Box as Box2,
ElevatedCard as ElevatedCard2,
FilledCard,
Flex as Flex7,
OutlinedCard,
Stack as Stack8
} from "@phx/design-system";

// src/components/illustration-card/illustrationcard.module.css
injectStyle(".XXQUga_illustrationWrapper{position:relative}.XXQUga_illustrationWrapper>img{z-index:1;position:relative}.XXQUga_cardContent{flex-grow:1}.XXQUga_illustrationShadow{background:var(--illustration-bg);block-size:var(--illustration-size);z-index:0;border-radius:50%;display:block;position:absolute;inset:0}@container XXQUga_card (width<160px){.XXQUga_flexRootxs{--illustration-card-flex-dir:column;--illustration-card-justify:normal}}@container XXQUga_card (width<200px){.XXQUga_flexRootsm{--illustration-card-flex-dir:column;--illustration-card-justify:normal}}@container XXQUga_card (width<240px){.XXQUga_flexRootmd{--illustration-card-flex-dir:column;--illustration-card-justify:normal}}@container XXQUga_card (width<280px){.XXQUga_flexRootlg{--illustration-card-flex-dir:column;--illustration-card-justify:normal}}@container XXQUga_card (width<400px){.XXQUga_flexRootxl{--illustration-card-flex-dir:column;--illustration-card-justify:normal}}");
var illustrationcard_module_default = { illustrationWrapper: "XXQUga_illustrationWrapper", flexRootlg: "XXQUga_flexRootlg", card: "XXQUga_card", flexRootxs: "XXQUga_flexRootxs", flexRootsm: "XXQUga_flexRootsm", flexRootxl: "XXQUga_flexRootxl", cardContent: "XXQUga_cardContent", flexRootmd: "XXQUga_flexRootmd", illustrationShadow: "XXQUga_illustrationShadow" };

// src/components/illustration-card/IllustrationCard.tsx
import {
jsx as jsx106,
jsxs as jsxs8
} from "react/jsx-runtime";
var variants = {
  bare: BareCard,
  elevated: ElevatedCard2,
  filled: FilledCard,
  outlined: OutlinedCard,
  highlighted: FilledCard
};
var flexDirection = {
  left: "row",
  right: "row-reverse",
  top: "column"
};
var IllustrationCard = ({
  children,
  header,
  Illustration: Illustration98,
  illustrationPosition = "left",
  illustrationSize = "sm",
  variant,
  withShadow = true,
  ...restProps
}) => {
  const Card = variants[variant];
  const color = restProps.color ?? "primary";
  const shade = variant === "filled" ? 1 : 0;
  const style = {
    flexDirection: `var(--illustration-card-flex-dir, ${flexDirection[illustrationPosition]})`,
    justifyContent: "var(--illustration-card-justify, normal)"
  };
  return /* @__PURE__ */ jsx106(Card, {
    ...restProps,
    withBorder: variant === "filled",
    children: /* @__PURE__ */ jsxs8(Flex7, {
      align: "center",
      gap: "sm",
      style,
      classNames: { root: illustrationcard_module_default[`flexRoot${illustrationSize}`] },
      children: [
        /* @__PURE__ */ jsxs8(Box2, {
          className: illustrationcard_module_default.illustrationWrapper,
          __vars: {
            "--illustration-bg": withShadow ? `var(--mantine-color-${color}-${shade})` : "transparent",
            "--illustration-size": ILLUSTRATION_SIZE[illustrationSize]
          },
          children: [
            /* @__PURE__ */ jsx106(Illustration98, {
              size: illustrationSize
            }),
            /* @__PURE__ */ jsx106(Box2, {
              className: illustrationcard_module_default.illustrationShadow
            })
          ]
        }),
        /* @__PURE__ */ jsxs8(Stack8, {
          className: illustrationcard_module_default.cardContent,
          gap: "xs",
          children: [
            header,
            children
          ]
        })
      ]
    })
  });
};

// src/components/med-form-icon/variants/MedFormAerosolSprayIcon.tsx
import {useTranslation as useTranslation99} from "react-i18next";

// src/components/med-form-icon/internal/MedFormIcon.tsx
import {rem as rem2} from "@phx/design-system/framework";
import {
jsx as jsx107
} from "react/jsx-runtime";
var InternalMedFormIcon = ({
  alt,
  svgFile
}) => {
  return /* @__PURE__ */ jsx107("img", {
    src: `/static/libraries/myphx-lib/med-form-icons/${svgFile}`,
    "aria-label": alt,
    style: {
      height: rem2("24px"),
      width: rem2("24px")
    },
    "data-testid": "med-form-icon"
  });
};

// src/components/med-form-icon/variants/MedFormAerosolSprayIcon.tsx
import {
jsx as jsx108
} from "react/jsx-runtime";
var MedFormAerosolSprayIcon = (props) => {
  const { t } = useTranslation99("phx-lib");
  return /* @__PURE__ */ jsx108(InternalMedFormIcon, {
    ...props,
    svgFile: "aerosol-spray-icon.svg",
    alt: t("medicationForm.aerosolSpray")
  });
};
// src/components/med-form-icon/variants/MedFormCapsuleIcon.tsx
import {useTranslation as useTranslation100} from "react-i18next";
import {
jsx as jsx109
} from "react/jsx-runtime";
var MedFormCapsuleIcon = (props) => {
  const { t } = useTranslation100("phx-lib");
  return /* @__PURE__ */ jsx109(InternalMedFormIcon, {
    ...props,
    svgFile: "capsule-icon.svg",
    alt: t("medicationForm.capsule")
  });
};
// src/components/med-form-icon/variants/MedFormCreamIcon.tsx
import {useTranslation as useTranslation101} from "react-i18next";
import {
jsx as jsx110
} from "react/jsx-runtime";
var MedFormCreamIcon = (props) => {
  const { t } = useTranslation101("phx-lib");
  return /* @__PURE__ */ jsx110(InternalMedFormIcon, {
    ...props,
    svgFile: "cream-icon.svg",
    alt: t("medicationForm.cream")
  });
};
// src/components/med-form-icon/variants/MedFormEnemaIcon.tsx
import {useTranslation as useTranslation102} from "react-i18next";
import {
jsx as jsx111
} from "react/jsx-runtime";
var MedFormEnemaIcon = (props) => {
  const { t } = useTranslation102("phx-lib");
  return /* @__PURE__ */ jsx111(InternalMedFormIcon, {
    ...props,
    svgFile: "enema-icon.svg",
    alt: t("medicationForm.enema")
  });
};
// src/components/med-form-icon/variants/MedFormGeneralIcon.tsx
import {useTranslation as useTranslation103} from "react-i18next";
import {
jsx as jsx112
} from "react/jsx-runtime";
var MedFormGeneralIcon = (props) => {
  const { t } = useTranslation103("phx-lib");
  return /* @__PURE__ */ jsx112(InternalMedFormIcon, {
    ...props,
    svgFile: "general-icon.svg",
    alt: t("medicationForm.form")
  });
};
// src/components/med-form-icon/variants/MedFormGranulePelletIcon.tsx
import {useTranslation as useTranslation104} from "react-i18next";
import {
jsx as jsx113
} from "react/jsx-runtime";
var MedFormGranulePelletIcon = (props) => {
  const { t } = useTranslation104("phx-lib");
  return /* @__PURE__ */ jsx113(InternalMedFormIcon, {
    ...props,
    svgFile: "granule-pellet-icon.svg",
    alt: t("medicationForm.granulePellet")
  });
};
// src/components/med-form-icon/variants/MedFormInhalerIcon.tsx
import {useTranslation as useTranslation105} from "react-i18next";
import {
jsx as jsx114
} from "react/jsx-runtime";
var MedFormInhalerIcon = (props) => {
  const { t } = useTranslation105("phx-lib");
  return /* @__PURE__ */ jsx114(InternalMedFormIcon, {
    ...props,
    svgFile: "inhaler-icon.svg",
    alt: t("medicationForm.inhaler")
  });
};
// src/components/med-form-icon/variants/MedFormInjectionIcon.tsx
import {useTranslation as useTranslation106} from "react-i18next";
import {
jsx as jsx115
} from "react/jsx-runtime";
var MedFormInjectionIcon = (props) => {
  const { t } = useTranslation106("phx-lib");
  return /* @__PURE__ */ jsx115(InternalMedFormIcon, {
    ...props,
    svgFile: "injection-icon.svg",
    alt: t("medicationForm.injection")
  });
};
// src/components/med-form-icon/variants/MedFormPatchIcon.tsx
import {useTranslation as useTranslation107} from "react-i18next";
import {
jsx as jsx116
} from "react/jsx-runtime";
var MedFormPatchIcon = (props) => {
  const { t } = useTranslation107("phx-lib");
  return /* @__PURE__ */ jsx116(InternalMedFormIcon, {
    ...props,
    svgFile: "patch-icon.svg",
    alt: t("medicationForm.patch")
  });
};
// src/components/med-form-icon/variants/MedFormPillIcon.tsx
import {useTranslation as useTranslation108} from "react-i18next";
import {
jsx as jsx117
} from "react/jsx-runtime";
var MedFormPillIcon = (props) => {
  const { t } = useTranslation108("phx-lib");
  return /* @__PURE__ */ jsx117(InternalMedFormIcon, {
    ...props,
    svgFile: "pill-icon.svg",
    alt: t("medicationForm.pill")
  });
};
// src/components/med-form-icon/variants/MedFormSolutionIcon.tsx
import {useTranslation as useTranslation109} from "react-i18next";
import {
jsx as jsx118
} from "react/jsx-runtime";
var MedFormSolutionIcon = (props) => {
  const { t } = useTranslation109("phx-lib");
  return /* @__PURE__ */ jsx118(InternalMedFormIcon, {
    ...props,
    svgFile: "solution-icon.svg",
    alt: t("medicationForm.solution")
  });
};
// src/components/med-form-icon/variants/MedFormSuppositoryIcon.tsx
import {useTranslation as useTranslation110} from "react-i18next";
import {
jsx as jsx119
} from "react/jsx-runtime";
var MedFormSuppositoryIcon = (props) => {
  const { t } = useTranslation110("phx-lib");
  return /* @__PURE__ */ jsx119(InternalMedFormIcon, {
    ...props,
    svgFile: "suppository-icon.svg",
    alt: t("medicationForm.suppository")
  });
};
// src/components/med-form-icon/MedFormIcon.tsx
import {
jsx as jsx120
} from "react/jsx-runtime";
var MedFormIcon13 = (props) => {
  switch (props.form?.toLowerCase()) {
    case "aerosol":
    case "aerosol-spray":
    case "aero pow br act":
      return /* @__PURE__ */ jsx120(MedFormAerosolSprayIcon, {});
    case "capsule":
      return /* @__PURE__ */ jsx120(MedFormCapsuleIcon, {});
    case "cream":
      return /* @__PURE__ */ jsx120(MedFormCreamIcon, {});
    case "enema":
      return /* @__PURE__ */ jsx120(MedFormEnemaIcon, {});
    case "granule":
    case "granule-pellet":
      return /* @__PURE__ */ jsx120(MedFormGranulePelletIcon, {});
    case "inhaler":
      return /* @__PURE__ */ jsx120(MedFormInhalerIcon, {});
    case "injection":
    case "soln auto-inj":
      return /* @__PURE__ */ jsx120(MedFormInjectionIcon, {});
    case "patch":
      return /* @__PURE__ */ jsx120(MedFormPatchIcon, {});
    case "pill":
    case "tablet":
      return /* @__PURE__ */ jsx120(MedFormPillIcon, {});
    case "solution":
      return /* @__PURE__ */ jsx120(MedFormSolutionIcon, {});
    case "suppository":
      return /* @__PURE__ */ jsx120(MedFormSuppositoryIcon, {});
    case "general":
    default:
      return /* @__PURE__ */ jsx120(MedFormGeneralIcon, {});
  }
};
// src/components/navigation-bar/NavigationBar.tsx
import {
Avatar as Avatar2,
Box as Box3,
Flex as Flex8,
IconButton,
IconChevronLeft,
IconMenu
} from "@phx/design-system";
import {getInitials as getInitials2} from "@phx/design-system/framework";
import {useMemo} from "react";
import {
jsx as jsx121,
jsxs as jsxs9
} from "react/jsx-runtime";
var NavigationBar = ({
  username,
  auth,
  onAvatarClick,
  onLogoClick,
  onBackButtonClick
}) => {
  const showBackButton = !!onBackButtonClick;
  const showAvatar = !!onAvatarClick;
  const initials = useMemo(() => {
    if (!auth) {
      return;
    }
    if (username) {
      return getInitials2(username);
    }
    return;
  }, [auth, username]);
  return /* @__PURE__ */ jsxs9(Flex8, {
    justify: "space-between",
    align: "center",
    p: "xxs",
    style: {
      width: "100%"
    },
    children: [
      /* @__PURE__ */ jsx121(Box3, {
        children: showBackButton ? /* @__PURE__ */ jsx121(IconButton, {
          Icon: IconChevronLeft,
          size: "sm",
          onClick: onBackButtonClick,
          color: "primary",
          disabled: false
        }) : null
      }),
      /* @__PURE__ */ jsx121("img", {
        src: "/static/libraries/myphx-lib/application-header/myprescryptive-logo.png",
        style: {
          width: "128px",
          height: "48px",
          cursor: onLogoClick ? "pointer" : "initial"
        },
        alt: "myprescryptive-logo",
        onClick: onLogoClick
      }),
      /* @__PURE__ */ jsx121(Box3, {
        children: showAvatar ? /* @__PURE__ */ jsx121(Avatar2, {
          onClick: onAvatarClick,
          size: "md",
          initials,
          AvatarIcon: initials ? undefined : IconMenu,
          color: "primary"
        }) : null
      })
    ]
  });
};

// src/components/offer-pricing/OfferPriceButton.tsx
import {
Body1 as Body15,
SelectionCard,
Stack as Stack9,
Subtitle1 as Subtitle12,
Subtitle2 as Subtitle24
} from "@phx/design-system";
import {
jsx as jsx122,
jsxs as jsxs10
} from "react/jsx-runtime";
var OfferPriceButton = ({
  price,
  onClick,
  title,
  subtitle,
  isSelected
}) => {
  return /* @__PURE__ */ jsx122(SelectionCard, {
    isSelected: !!isSelected,
    color: "primary",
    onClick,
    children: /* @__PURE__ */ jsxs10(Stack9, {
      gap: "xxxs",
      children: [
        /* @__PURE__ */ jsx122(Subtitle24, {
          children: title
        }),
        price && /* @__PURE__ */ jsx122(Subtitle12, {
          children: price
        }),
        /* @__PURE__ */ jsx122(Body15, {
          children: subtitle
        })
      ]
    })
  });
};

// src/components/offer-pricing/CashOfferPriceButton.tsx
import {useTranslation as useTranslation111} from "react-i18next";
import {
jsx as jsx123
} from "react/jsx-runtime";
var CashOfferPriceButton = ({
  price,
  onClick,
  isSelected
}) => {
  const { t } = useTranslation111("phx-lib");
  const subtitle = price ? t("pricing.withoutInsurance") : t("pricing.unknown");
  return /* @__PURE__ */ jsx123(OfferPriceButton, {
    title: t("pricing.smartPrice"),
    subtitle,
    isSelected,
    onClick,
    price
  });
};

// src/components/offer-pricing/InsuranceOfferPriceButton.tsx
import {useTranslation as useTranslation112} from "react-i18next";
import {
jsx as jsx124
} from "react/jsx-runtime";
var InsuranceOfferPriceButton = ({
  price,
  planPays,
  onClick,
  isSelected
}) => {
  const { t } = useTranslation112("phx-lib");
  const subtitle = price && planPays ? t("pricing.planPays", { planPays }) : t("pricing.unknown");
  return /* @__PURE__ */ jsx124(OfferPriceButton, {
    title: t("pricing.insurancePrice"),
    subtitle,
    isSelected,
    onClick,
    price
  });
};

// src/components/pharmacy-card/PharmacyCard.tsx
import {ElevatedCard as ElevatedCard3} from "@phx/design-system";

// src/components/pharmacy-card/internal/CardContent.tsx
import {Stack as Stack11, Subtitle2 as Subtitle25} from "@phx/design-system";

// src/components/pharmacy-card/internal/HeaderGroup.tsx
import {
Body1 as Body16,
Flex as Flex9,
IconFavorite,
Stack as Stack10,
Subtitle1 as Subtitle13,
ToggleButton
} from "@phx/design-system";
import {
jsx as jsx125,
jsxs as jsxs11
} from "react/jsx-runtime";
var HeaderGroup3 = ({
  title,
  toggleFavorite,
  description,
  additionalInfo,
  value,
  favorite = false
}) => {
  return /* @__PURE__ */ jsxs11(Flex9, {
    justify: "space-between",
    children: [
      /* @__PURE__ */ jsxs11(Stack10, {
        gap: "xxs",
        children: [
          /* @__PURE__ */ jsx125(Subtitle13, {
            children: title
          }),
          /* @__PURE__ */ jsxs11(Stack10, {
            gap: "xxxs",
            children: [
              /* @__PURE__ */ jsx125(Body16, {
                children: description?.join(" \u2022 ")
              }),
              additionalInfo ? /* @__PURE__ */ jsx125(Body16, {
                children: additionalInfo
              }) : null
            ]
          }),
          value ? /* @__PURE__ */ jsx125(Body16, {
            children: value
          }) : null
        ]
      }),
      toggleFavorite ? /* @__PURE__ */ jsx125(ToggleButton, {
        checked: favorite,
        Icon: IconFavorite,
        CheckedIcon: IconFavorite,
        iconProps: { filled: favorite },
        color: "error",
        disabled: false,
        toggle: toggleFavorite
      }) : null
    ]
  });
};

// src/components/pharmacy-card/internal/CardContent.tsx
import {
jsx as jsx126,
jsxs as jsxs12
} from "react/jsx-runtime";
var CardContent = ({
  title,
  description,
  pricing,
  value,
  additionalInfo,
  subtitle,
  footer,
  toggleFavorite,
  favorite = false
}) => {
  const hasValidPriceList = !!pricing?.length;
  const altText = subtitle ? /* @__PURE__ */ jsx126(Subtitle25, {
    children: subtitle
  }) : null;
  return /* @__PURE__ */ jsxs12(Stack11, {
    gap: "md",
    children: [
      /* @__PURE__ */ jsx126(HeaderGroup3, {
        title,
        toggleFavorite,
        description,
        value,
        favorite,
        additionalInfo
      }),
      /* @__PURE__ */ jsx126(Stack11, {
        gap: "sm",
        children: hasValidPriceList ? /* @__PURE__ */ jsx126(PricingInfoList, {
          pricing
        }) : altText
      }),
      footer
    ]
  });
};

// src/components/pharmacy-card/PharmacyCard.tsx
import {
jsx as jsx127
} from "react/jsx-runtime";
var PharmacyCard = ({
  title,
  description,
  pricing,
  value,
  subtitle,
  footer,
  toggleFavorite,
  additionalInfo,
  onClick,
  role,
  favorite = false
}) => {
  return /* @__PURE__ */ jsx127(ElevatedCard3, {
    onClick,
    role,
    children: /* @__PURE__ */ jsx127(CardContent, {
      title,
      description,
      pricing,
      additionalInfo,
      value,
      subtitle,
      toggleFavorite,
      footer,
      favorite
    })
  });
};

// src/components/pharmacy-card/HighlightPharmacyCard.tsx
import {
HighlightedCard,
IconInfo
} from "@phx/design-system";
import {
jsx as jsx128
} from "react/jsx-runtime";
var HighlightPharmacyCard = ({
  variant,
  header,
  title,
  description,
  pricing,
  value,
  subtitle,
  toggleFavorite,
  onIconClick,
  onClick,
  additionalInfo,
  footer,
  role,
  favorite
}) => {
  return /* @__PURE__ */ jsx128(HighlightedCard, {
    Icon: IconInfo,
    onIconClick,
    iconPosition: "right",
    header,
    color: variant === "Featured" ? "info" : "primary",
    onClick,
    role,
    children: /* @__PURE__ */ jsx128(CardContent, {
      title,
      description,
      pricing,
      value,
      additionalInfo,
      subtitle,
      toggleFavorite,
      footer,
      favorite
    })
  });
};

// src/components/pharmacy-info/PharmacyInfo.tsx
import {useAuthContext} from "@phx/auth/client";
import {
Address as Address2,
Delivery,
Distance as Distance2,
Flex as Flex11,
IconFavorite as IconFavorite2,
PhoneNumber as PhoneNumber3,
Stack as Stack13,
Subtitle1 as Subtitle14,
ToggleButton as ToggleButton2,
Website
} from "@phx/design-system";

// /home/vsts/work/1/s/node_modules/@phx/my-prescryptive/src/components/utility/ConditionalComponent.tsx
import {
jsx as jsx129,
Fragment as Fragment2
} from "react/jsx-runtime";
var ConditionalComponent = ({
  condition,
  children
}) => {
  const result = typeof condition === "function" ? condition() : condition;
  if (result) {
    return /* @__PURE__ */ jsx129(Fragment2, {
      children
    });
  }
  return null;
};

// src/components/pharmacy-info/PharmacyHours.tsx
import {
HoursByDay,
HoursOfOperation
} from "@phx/design-system";
import {
jsx as jsx130
} from "react/jsx-runtime";
var PharmacyHours = ({
  day,
  hours,
  showIcon,
  weeklyHours
}) => {
  if (Array.isArray(hours)) {
    const isValidTime = !!hours[0] && !!hours[1];
    return /* @__PURE__ */ jsx130(HoursOfOperation, {
      day: isValidTime ? day : undefined,
      weeklyHours,
      times: hours,
      showIcon,
      inline: true
    });
  }
  return /* @__PURE__ */ jsx130(HoursByDay, {
    hours,
    showIcon
  });
};

// src/components/pharmacy-info/PharmacyInfoCompact.tsx
import {
Address,
Box as Box4,
Distance,
Flex as Flex10,
PhoneNumber as PhoneNumber2,
Stack as Stack12
} from "@phx/design-system";
import {
jsx as jsx131,
jsxs as jsxs13,
Fragment as Fragment3
} from "react/jsx-runtime";
var PharmacyInfoCompact = ({
  address,
  distance,
  phone,
  hours,
  locale = "en-US"
}) => {
  const locationDetails = [];
  if (distance) {
    locationDetails.push(/* @__PURE__ */ jsx131(Distance, {
      showIcon: false,
      ...distance,
      locale
    }));
  }
  if (address) {
    locationDetails.push(/* @__PURE__ */ jsx131(Address, {
      showIcon: false,
      address
    }));
  }
  return /* @__PURE__ */ jsxs13(Stack12, {
    gap: "xxs",
    children: [
      locationDetails.length ? /* @__PURE__ */ jsx131(Flex10, {
        gap: "xxxs",
        align: "center",
        children: locationDetails.map((line, idx) => /* @__PURE__ */ jsxs13(Fragment3, {
          children: [
            /* @__PURE__ */ jsx131(Box4, {
              children: line
            }, idx),
            idx !== locationDetails.length - 1 && " \u2022 "
          ]
        }))
      }) : null,
      hours ? /* @__PURE__ */ jsx131(PharmacyHours, {
        showIcon: false,
        hours
      }) : undefined,
      phone ? /* @__PURE__ */ jsx131(PhoneNumber2, {
        showIcon: false,
        phone
      }) : undefined
    ]
  });
};

// src/components/pharmacy-info/PharmacyInfo.tsx
import {
jsx as jsx132,
jsxs as jsxs14
} from "react/jsx-runtime";
var PharmacyInfo = ({
  name,
  shippingTime,
  address,
  distance,
  phone,
  compact = false,
  hours,
  day,
  weeklyHours,
  url,
  locale = "en-US",
  favorite = false,
  toggleFavorite
}) => {
  const { isAuthenticated } = useAuthContext();
  return /* @__PURE__ */ jsxs14(Stack13, {
    gap: "xxs",
    "data-testid": "pharmacy-info",
    children: [
      /* @__PURE__ */ jsxs14(Flex11, {
        align: "center",
        justify: "space-between",
        children: [
          /* @__PURE__ */ jsx132(Subtitle14, {
            "data-testid": "pharmacy-name",
            children: name
          }),
          /* @__PURE__ */ jsx132(ConditionalComponent, {
            condition: isAuthenticated && !!toggleFavorite,
            children: /* @__PURE__ */ jsx132(ToggleButton2, {
              checked: favorite,
              disabled: false,
              Icon: IconFavorite2,
              CheckedIcon: IconFavorite2,
              iconProps: { filled: favorite },
              color: "error",
              toggle: toggleFavorite
            })
          })
        ]
      }),
      compact ? /* @__PURE__ */ jsx132(PharmacyInfoCompact, {
        address,
        distance,
        phone,
        hours,
        locale
      }) : /* @__PURE__ */ jsxs14(Stack13, {
        gap: "sm",
        children: [
          address ? /* @__PURE__ */ jsx132(Address2, {
            address
          }) : null,
          distance ? /* @__PURE__ */ jsx132(Distance2, {
            ...distance,
            locale
          }) : null,
          shippingTime ? /* @__PURE__ */ jsx132(Delivery, {
            shippingTime
          }) : null,
          phone ? /* @__PURE__ */ jsx132(PhoneNumber3, {
            phone
          }) : null,
          url ? /* @__PURE__ */ jsx132(Website, {
            url
          }) : null,
          hours ? /* @__PURE__ */ jsx132(PharmacyHours, {
            weeklyHours,
            hours,
            day
          }) : null
        ]
      })
    ]
  });
};

// src/components/spend-summary-card/SpendSummaryCard.tsx
import {
Body1 as Body17,
Currency,
Flex as Flex12,
Heading3,
Heading4,
HorizontalDivider as HorizontalDivider2,
IconGroup,
IconPerson,
OutlinedCard as OutlinedCard2,
ProgressBar
} from "@phx/design-system";
import {useTranslation as useTranslation113} from "react-i18next";
import {
jsx as jsx133,
jsxs as jsxs15
} from "react/jsx-runtime";
var formatters = {
  max: (max, current) => /* @__PURE__ */ jsx133(Heading4, {
    children: /* @__PURE__ */ jsx133(Currency, {
      amount: max - current
    })
  }),
  min: (min, current) => /* @__PURE__ */ jsx133(Heading4, {
    children: /* @__PURE__ */ jsx133(Currency, {
      amount: current - min
    })
  })
};
var SpendSummaryCard = ({
  deductible,
  outOfPocket,
  variant,
  "data-testid": testId
}) => {
  const { t } = useTranslation113("phx-lib");
  const Icon = variant === "individual" ? IconPerson : IconGroup;
  return /* @__PURE__ */ jsx133(OutlinedCard2, {
    "data-testid": testId,
    children: /* @__PURE__ */ jsxs15(Flex12, {
      direction: "column",
      gap: "sm",
      children: [
        /* @__PURE__ */ jsx133(Heading3, {
          children: /* @__PURE__ */ jsxs15(Flex12, {
            gap: "xxs",
            children: [
              /* @__PURE__ */ jsx133(Icon, {}),
              variant === "individual" ? t("spendSummaryCard.individual") : t("spendSummaryCard.family")
            ]
          })
        }),
        /* @__PURE__ */ jsx133(HorizontalDivider2, {}),
        /* @__PURE__ */ jsxs15(Flex12, {
          direction: "column",
          "data-testid": "deductible-amount-per-year",
          children: [
            /* @__PURE__ */ jsx133(Body17, {
              children: t("spendSummaryCard.deductible")
            }),
            /* @__PURE__ */ jsxs15(Heading4, {
              children: [
                /* @__PURE__ */ jsx133(Currency, {
                  amount: deductible.max
                }),
                t("spendSummaryCard.year")
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsx133(ProgressBar, {
          startLabel: t("spendSummaryCard.spent"),
          endLabel: t("spendSummaryCard.toGo"),
          max: deductible.max,
          maxFormatter: formatters.max,
          min: 0,
          minFormatter: formatters.min,
          value: deductible.spent
        }),
        /* @__PURE__ */ jsxs15(Flex12, {
          direction: "column",
          mt: "0.5rem",
          "data-testid": "outOfPocket-amount-per-year",
          children: [
            /* @__PURE__ */ jsx133(Body17, {
              children: t("spendSummaryCard.maxOutOfPocket")
            }),
            /* @__PURE__ */ jsxs15(Heading4, {
              children: [
                /* @__PURE__ */ jsx133(Currency, {
                  amount: outOfPocket.max
                }),
                t("spendSummaryCard.year")
              ]
            })
          ]
        }),
        /* @__PURE__ */ jsx133(ProgressBar, {
          startLabel: t("spendSummaryCard.spent"),
          endLabel: t("spendSummaryCard.toGo"),
          max: outOfPocket.max,
          maxFormatter: formatters.max,
          min: 0,
          minFormatter: formatters.min,
          value: outOfPocket.spent
        })
      ]
    })
  });
};
export {
  ZeroFeesIllustration,
  VaccineIllustration,
  UpToDateIllustration,
  UnexpectedErrorIllustration,
  UnderMaintenanceIllustration,
  TwentyFourHoursIllustration,
  TransportIllustration,
  TransparencyIllustration,
  TransferFailedIllustration,
  TimeExpiredIllustration,
  TextUpdatesIllustration,
  TextReceivedIllustration,
  TestTubesIllustration,
  SwitchMedicinesIllustration,
  StethoscopeIllustration,
  SpendSummaryCard,
  SmartphoneIllustration,
  ShoppingCartIllustration,
  ShoppingBagIllustration,
  ShieldIllustration,
  SaveMoneyIllustration,
  ReportsIllustration,
  ProtectionIllustration,
  PricingInfoList,
  PricingInfo,
  PrescriptionIllustration,
  PredictiveModelIllustration,
  PillsIllustration,
  PiggybankIllustration,
  PharmacyInfo,
  PharmacyIllustration,
  PharmacyHours,
  PharmacyCard,
  PharmaIllustration,
  OfferPriceButton,
  NutritionalBoardIllustration,
  NotepadIllustration,
  NoResultsIllustration,
  NoPillsIllustration,
  NoMoneyIllustration,
  NoClaimsIllustration,
  NavigationBar,
  MoneyGrowthIllustration,
  MoneyDownIllustration,
  MobileExperienceIllustration,
  MixingBowlIllustration,
  MemberIdIllustration,
  MegaphoneIllustration,
  MedicineIllustration,
  MedFormSuppositoryIcon,
  MedFormSolutionIcon,
  MedFormPillIcon,
  MedFormPatchIcon,
  MedFormInjectionIcon,
  MedFormInhalerIcon,
  MedFormIcon13 as MedFormIcon,
  MedFormGranulePelletIcon,
  MedFormGeneralIcon,
  MedFormEnemaIcon,
  MedFormCreamIcon,
  MedFormCapsuleIcon,
  MedFormAerosolSprayIcon,
  MaleUserIllustration,
  MailOrderIllustration,
  MagnifierAlertIllustration,
  LockIllustration,
  LocationIllustration,
  LocationFailedIllustration,
  LightingIllustration,
  LightbulbIllustration,
  LaptopIllustration,
  LabSampleIllustration,
  InsuranceOfferPriceButton,
  IllustrationCard,
  IdeaIllustration,
  HighlightPharmacyCard,
  HandshakeIllustration,
  HandsWithPhoneIllustration,
  GrowthIllustration,
  GroupIllustration,
  GroupIdeaIllustration,
  GlobalConnectionIllustration,
  GearIllustration,
  FlexibleAligmentIllustration,
  FirstAidKitIllustration,
  FemaleUserIllustration,
  FemaleDoctorIllustration,
  FamilyIllustration,
  Error404Illustration,
  EmptyCabinetIllustration,
  EmployersAndConsultantsIllustration,
  EasyToUseIllustration,
  DocumentsIllustration,
  DirectionsIllustration,
  DirectEngagementIllustration,
  DependentItem,
  DatabaseIllustration,
  CoverageCard,
  ContactBookIllustration,
  ConsumersIllustration,
  ConferenceIllustration,
  ComparePricesIllustration,
  CoinIllustration,
  CloudIllustration,
  ClaimDeniedIllustration,
  ChecklistIllustration,
  CashOfferPriceButton,
  CardIllustration,
  CalendarIllustration,
  CalculatorIllustration,
  BrainIllustration,
  BoxIllustration,
  BottleAndPillsIllustration,
  BottleAndCapsulesIllustration,
  BoardIllustration,
  BikeIllustration,
  BIllustration,
  AvatarIllustration,
  AnalyticsIllustration,
  AlternativeCard,
  AdherenceAddressedIllustration,
  AddHomeIllustration,
  ActivityItem,
  AIDrivenIllustration
};

//# debugId=1BB131DC60B20EEA64756E2164756E21
